// Videos.jsx
import React, { useRef, useState, useEffect } from 'react';
import styles from "../css/CatalogoVideos.module.css"
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import { Snackbar, Alert, Fab, FormControl, InputLabel, Select, MenuItem, TextField, FormControlLabel, Switch, Typography } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import Wait from "../components/Wait";

import miAxios from '../api/axios';
import { useAuth } from '../hooks/AuthProvider';
import Confirmacion from '../components/Conformacion';
import Items from '../components/Items';
import Video from '../components/Video';
import { Grid } from '@mui/system';
import VideoThumbnail from '../components/VideoThumbnail';


export default function Videos(props) {
    const [mensaje, setMensaje] = useState("");
    const [procesando, setProcesando] = useState(false);
    const [openConfirmacion, setOpenConfirmacion] = useState(false);
    const [openItem, setOpenItem] = useState({ open: false, id: 0 })
    const [incluyeInactivos, setIncluyeInactivos] = useState(false)
    const [rows, setRows] = useState([])
    const [rutaAzure, setRutaAzure] = useState("")

    const user = useAuth()
    const axios = miAxios(user.handleLogout)

    useEffect(() => {
        actVideos()
    }, [])

    useEffect(() => {
        actVideos()
    }, [incluyeInactivos])

    const actVideos = async () => {
        setProcesando(true)
        try {
            const response = await axios.get("videos/listado?incluye_inactivos=" + (incluyeInactivos ? "1" : "0"))

            const data = response.data;
            if (data.respuesta == "S") {
                setRows(data.lista)
                setRutaAzure(data.rutaAzure)
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    const handleCerrarVideo = () => {
        setOpenItem({ open: false, id: 0 })
        actVideos()
    }

    const handleInactivar = async (cual) => {

        setProcesando(true)
        try {
            const response = await axios.post("videos/inactivar?video=" + cual)

            const data = response.data;
            if (data.respuesta == "S") {
                actVideos()
            } else {
                setMensaje(data.mensaje)
            }
        } catch (error) {
            console.log(error)
            setMensaje(error)
        }

        setProcesando(false)
    }

    return <div className={styles.cuerpo}>
        <Wait procesando={procesando} />
        <Snackbar
            open={mensaje.length === 0 ? false : true}
            autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={() => { setMensaje("") }}
        >
            <Alert severity="error" onClose={() => { setMensaje("") }} variant="filled">{mensaje}</Alert>
        </Snackbar>
        <Confirmacion open={openConfirmacion} texto={"¿Desea publicar este video?"} cancelar={() => { setOpenConfirmacion(false) }} />
        <Video open={openItem.open} id={openItem.id} cerrar={handleCerrarVideo} />

        <div className={styles.titulo}>
            Nuestros Videos
        </div>
        <div className={styles.filtro}>
            <div className={styles.add}>
                <Fab color="coopinfa" onClick={() => { setOpenItem({ open: true, id: 0 }) }} size="small">
                    <AddIcon />
                </Fab>
            </div>
            <Grid container spacing={2}>
                <Grid size={12} sx={{ display: "flex", alignItems: "center" }}>
                    <FormControlLabel
                        control={<Switch size="small" checked={incluyeInactivos}
                            color="coopinfa"
                            onChange={(event) => { setIncluyeInactivos(event.target.checked) }} />}
                        label="Incluir inactivos"
                    />
                </Grid>
            </Grid>
        </div>
        <div className={styles.catalogo}>
            {
                rows.map((row, index) => {
                    const f = JSON.parse(row.instantaneas)
                    const n = f.map((foto) => rutaAzure + foto.url)
                    return <div className={styles.items}>
                        <div className={styles.div_items}>
                            <VideoThumbnail
                                snapshots={n}
                                interval={2000}
                            />
                        </div>
                        <Grid container spacing={2} sx={{ paddingTop: "40px" }}>
                            <Grid size={12}>
                                <TextField
                                    size='small'
                                    disabled
                                    label="Fecha Creación"
                                    value={row.fecha}
                                />
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    size='small'
                                    disabled
                                    label="Fecha Vence"
                                    value={row.vence}
                                />
                            </Grid>
                            <Grid size={6}>
                                {parseInt(row.vencido) == 0 && (<FormControlLabel
                                    control={<Switch size="small" checked={row.inactivo}
                                        onChange={() => { handleInactivar(row.id) }}
                                        disabled={row.inactivo}
                                        color="coopinfa"
                                    />}
                                    label="Inactivo"
                                />)}
                            </Grid>
                            <Grid size={6}>
                                {
                                    parseInt(row.vencido) != 0 ? <Typography variant='h6' sx={{color: "red"}}>Vencido</Typography> : null
                                }
                            </Grid>
                        </Grid>
                    </div>
                }
                )
            }
        </div>

    </div>
}